import { render, staticRenderFns } from "./EventReportDetails.vue?vue&type=template&id=c2cd6a00&scoped=true"
import script from "./EventReportDetails.vue?vue&type=script&lang=ts"
export * from "./EventReportDetails.vue?vue&type=script&lang=ts"
import style0 from "./EventReportDetails.vue?vue&type=style&index=0&id=c2cd6a00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cd6a00",
  null
  
)

export default component.exports